import { useEffect, useRef } from 'react'
import type { RefObject } from 'react'

import { focusFirstFocusableInElement } from 'utils/accessibility'

const useCarouselFocus = (ref: RefObject<HTMLElement>, currentIndex: number, enabled = true) => {
  const prevIndexRef = useRef<number | undefined>(undefined)

  useEffect(() => {
    if (enabled && prevIndexRef.current !== undefined && prevIndexRef.current !== currentIndex) {
      if (ref.current) {
        focusFirstFocusableInElement(ref.current)
      }
    }
    prevIndexRef.current = currentIndex
  }, [currentIndex, enabled, ref])
}

export default useCarouselFocus
